export default function SelectionBar({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <>
      <div className="absolute bottom-0 right-0 flex w-full justify-end gap-x-4 border-t border-solid border-t-stroke-line bg-secondary-background px-4 py-2">
        {children}
      </div>
    </>
  );
}
